import myDriverTypes from './myDriverTypes'

export const initialState = {
  filters: {
    driverName: '',
    phoneNumber: '',
    locationState: '',
    status: '',
    offset: 0
  },
  loadMore: false,
  loadPage: true,
  error: '',
  drivers: [],
  noMore: false,
  setLoad: false,
  deleteLoad: false,
  setError: '',
  deleteError: ''
}

export default (state = initialState, { type, payload }) => {
  switch (type) {
    case myDriverTypes.GET_DRVIERS:
      return {
        ...state,
        loadMore: true,
        error: ''
      }

    case myDriverTypes.GET_DRVIERS_SUCCESS: {
      const { offset } = state.filters

      let { data: drivers, results } = payload
      let noMore = false

      if (offset !== 0) {
        drivers = [...state.drivers, ...drivers]
      }

      if (drivers.length >= results) {
        noMore = true
      }

      return {
        ...state,
        drivers,
        noMore,
        loadMore: false,
        loadPage: false,
        error: ''
      }
    }

    case myDriverTypes.GET_DRVIERS_FAILURE: {
      return {
        ...state,
        loadMore: false,
        loadPage: false,
        error: payload,
        drivers: []
      }
    }

    case myDriverTypes.CLEAR_DRVIERS: {
      return {
        ...state,
        drivers: []
      }
    }

    case myDriverTypes.SET_FILTERS : {
      const filters = (!payload) ? { ...initialState.filters } : {
        ...state.filters,
        ...payload,
        offset: 0
      }

      return {
        ...state,
        filters,
        loadPage: true
      }
    }

    case myDriverTypes.LOAD_MORE:
      return {
        ...state,
        filters: {
          ...state.filters,
          offset: state.filters.offset + payload
        },
        loadMore: true
      }

    case myDriverTypes.SET_DRVIERS:
      return {
        ...state,
        setLoad: true,
        setError: ''
      }

    case myDriverTypes.SET_DRVIERS_SUCCESS: {
      let drivers = state.drivers
      const index = drivers.findIndex(({ driver_id }) => driver_id === payload.driver_id)
      const newDirver = {
        ...payload,
        location: payload.location ? {
          ...payload.location,
          state_code: payload.location.state_id || payload.location.state_code
        } : null
      }

      if (index !== -1) {
        drivers[index] = newDirver
      } else {
        drivers = [newDirver, ...drivers]
      }

      return {
        ...state,
        setLoad: false,
        setError: '',
        drivers
      } }

    case myDriverTypes.SET_DRVIERS_FAILURE:
      return {
        ...state,
        setLoad: false,
        setError: payload
      }

    case myDriverTypes.DELETE_DRVIERS:
      return {
        ...state,
        deleteLoad: true,
        deleteError: ''
      }

    case myDriverTypes.DELETE_DRVIERS_SUCCESS: {
      const drivers = state.drivers.filter(({ driver_id }) => driver_id !== payload)
      return {
        ...state,
        deleteLoad: false,
        deleteError: '',
        drivers
      }
    }

    case myDriverTypes.DELETE_DRVIERS_FAILURE:
      return {
        ...state,
        deleteLoad: false,
        deleteError: payload
      }

    default: return state
  }
}
